import { AlertTriangle, SearchX } from "lucide-react";

import { ColocaEmpty } from "@/shared/components/feedback/ColocaEmpty";
import { useTranslations } from "@/shared/lang/useTranslations";

export interface AccessUsersEmptyProps {
  /** The list came back empty because the request failed, not because nobody matches. */
  loadFailed: boolean;
}

/**
 * The users list's empty state, shared by the table and the cards.
 *
 * "No results" and "the request failed" both leave the list empty and only one of them means nobody matches —
 * saying the wrong one is how an operator concludes a user does not exist. Shared so the two faces cannot
 * answer that differently.
 *
 * `surface="card"` because this always renders inside a card: the default hatched page background would read
 * as a hole punched in the surface.
 */
export function AccessUsersEmpty({ loadFailed }: AccessUsersEmptyProps) {
  const { t } = useTranslations("settings");

  return (
    <ColocaEmpty
      icon={loadFailed ? AlertTriangle : SearchX}
      title={loadFailed ? t("access_users_load_failed") : t("access_no_results")}
      surface="card"
    />
  );
}
